import React from 'react';

import { DelayedSearch } from './delayed-search';
import { GeneralConstants } from '../constants/general-constants';
import { Category } from '../model/cris/category';
import { KnpPaginationData } from '../model/knp-pagination-data';
import { categoryService } from '../services/category.service';

interface CrisCategoryPickerProps {
    value?: Category;
    size?: 'medium' | 'small';
    name?: string;

    onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>, value?: Category) => void;
}

export class CrisCategoryPicker extends React.Component<CrisCategoryPickerProps> {
    public render(): React.ReactNode {
        return (
            <DelayedSearch
                {...this.props}
                freeSolo={false}
                value={this.props.value || GeneralConstants.COMPONENT_VALUE_NULL}
                variant='standard'
                label='Pick A Category'
                onSearch={(data) =>
                    categoryService.list({
                        pageSize: GeneralConstants.PAGE_SIZE_LARGE,
                        filters: {
                            name: data,
                        },
                    })
                }
                mapDataToOptions={(data: KnpPaginationData<Category>) => data.data}
                getOptionLabel={(data) => `${data?.category || ''}`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
            />
        );
    }
}
